import './vectorRuntime'

const params = new URLSearchParams(location.search)
const total = Math.max(0, Number(params.get('simulate') || 0))

if (total > 0) {
  const app = document.getElementById('app') as HTMLElement | null
  const game = document.getElementById('game') as HTMLElement | null
  const capyBody = document.getElementById('capyBody') as HTMLElement | null
  const capyWrap = document.getElementById('capyWrap') as HTMLElement | null
  const buyBtn = document.getElementById('buyBtn') as HTMLButtonElement | null
  const winCard = document.getElementById('winCard') as HTMLElement | null
  const winWallet = document.getElementById('winWallet') as HTMLElement | null
  const tearField = document.getElementById('tearField') as HTMLElement | null
  const eyeLeft = document.getElementById('eyeLeft') as unknown as SVGCircleElement | null
  const eyeRight = document.getElementById('eyeRight') as unknown as SVGCircleElement | null

  if (app && game && capyBody && capyWrap && tearField) {
    document.body.classList.add('simulation-mode')
    app.classList.add('simulation-mode')
    if (buyBtn) buyBtn.disabled = true

    const badge = document.createElement('div')
    badge.className = 'sim-counter'
    document.body.appendChild(badge)

    const fxLayer = document.createElement('div')
    fxLayer.className = 'sim-fx-layer'
    capyWrap.appendChild(fxLayer)

    const head = document.getElementById('rigHead') as unknown as SVGGraphicsElement | null
    const armLeft = document.getElementById('armLeft') as unknown as SVGGraphicsElement | null
    const armRight = document.getElementById('armRight') as unknown as SVGGraphicsElement | null
    const glasses = document.getElementById('glasses') as unknown as SVGGraphicsElement | null
    const chain = document.getElementById('chain') as unknown as SVGGraphicsElement | null

    const duration = 64_000
    const uniqueEvents = Math.min(500, total)
    const ruptureStride = Math.max(1, Math.floor(total / Math.max(1, uniqueEvents)))
    const pumpStride = Math.max(1, Math.floor(total / 50))
    const tearStride = Math.max(1, Math.floor(total / 42))
    const milestones = [.045,.09,.135,.18,.23,.28,.33,.38,.43,.48,.54,.60,.66,.72,.78,.84,.89,.93,.965,.992]

    let lastTx = 0
    let nextRupture = ruptureStride
    let nextTear = tearStride
    let cycle = 0
    let raf = 0
    const fired = new Set<number>()

    function hash(n: number) {
      let x = n | 0
      x ^= x << 13
      x ^= x >>> 17
      x ^= x << 5
      return x >>> 0
    }

    function setVisual(p: number) {
      const smooth = p * p * (3 - 2 * p)
      const balloon = Math.pow(p, 1.18)
      const sx = 1 + .66 * balloon
      const sy = 1 + .14 * balloon

      capyBody.style.setProperty('--sx', sx.toFixed(4))
      capyBody.style.setProperty('--sy', sy.toFixed(4))
      capyBody.style.setProperty('--eye-red', String(Math.max(0, Math.min(1, (p - .08) / .80))))
      capyBody.style.setProperty('--pressure', String(p))

      if (head) head.style.transform = `translateY(${-11 * smooth}px) scaleX(${1 + .10 * balloon})`
      if (armLeft) armLeft.style.transform = `translate(${-24 * balloon}px,${4 * smooth}px) rotate(${-9 * smooth}deg)`
      if (armRight) armRight.style.transform = `translate(${24 * balloon}px,${4 * smooth}px) rotate(${9 * smooth}deg)`
      if (glasses && p < .78) glasses.style.transform = `translateY(${8 * balloon}px) rotate(${Math.sin(p * 17) * p * 2.6}deg)`
      if (chain && p < .72) chain.style.transform = `translateY(${10 * balloon}px) scaleX(${1 + .10 * balloon})`

      const red = Math.max(0, Math.min(1, (p - .10) / .78))
      const eyeColor = `rgb(${Math.round(20 + red * 235)},${Math.round(20 - red * 14)},${Math.round(20 - red * 14)})`
      for (const eye of [eyeLeft, eyeRight]) {
        if (!eye) continue
        eye.style.fill = eyeColor
        eye.style.filter = red > .12 ? `drop-shadow(0 0 ${2 + red * 9}px rgba(255,0,0,.95))` : 'none'
        eye.setAttribute('r', String(11 + red * 3.2))
      }

      app.dataset.pressure = p > .88 ? '3' : p > .67 ? '2' : p > .43 ? '1' : '0'
      app.dataset.simStage = String(p > .985 ? 6 : p > .92 ? 5 : p > .79 ? 4 : p > .61 ? 3 : p > .38 ? 2 : p > .16 ? 1 : 0)
    }

    function pump() {
      game.classList.remove('pumping')
      capyBody.classList.remove('puff')
      void game.offsetWidth
      game.classList.add('pumping')
      capyBody.classList.add('puff')
      window.setTimeout(() => {
        game.classList.remove('pumping')
        capyBody.classList.remove('puff')
      }, 440)
    }

    function eventSpec(index: number, intensity: number) {
      const h = hash((index + 1) * 1103515245 + cycle * 7919)
      const zones = [
        [25,45],[34,47],[43,49],[51,50],[60,48],[69,46],[76,50],
        [24,57],[34,59],[43,61],[52,62],[61,60],[70,58],[77,61],
        [27,70],[37,72],[47,73],[57,73],[67,71],[75,69],
      ]
      const [bx, by] = zones[index % zones.length]!
      const side = (h & 1) ? 1 : -1
      const kinds = index < 250
        ? ['cloth','thread','cloth','button','cloth','thread']
        : index < 380
          ? ['cloth','chain','thread','glass','button','cloth']
          : ['cloth','glass','chain','shoe','spark','cloth','thread']
      return {
        kind: kinds[index % kinds.length]!,
        x: bx + ((h >>> 7) % 7) - 3,
        y: by + ((h >>> 11) % 7) - 3,
        dx: side * (90 + (h % 180)) * (.72 + intensity * .95),
        dy: -(75 + ((h >>> 4) % 175)) * (.72 + intensity * .95),
        rot: side * (90 + ((h >>> 16) % 420)),
        size: (15 + ((h >>> 22) % 22)) * (.82 + intensity * .7),
        color: ['#18bff0','#ff2da6','#ffd52d','#6d37e8','#f28a21','#fff8ed'][index % 6]!,
      }
    }

    function emitRupture(index: number, intensity: number, forceCount?: number) {
      const s = eventSpec(index, intensity)
      const count = forceCount ?? (intensity > .58 ? 2 : 1)
      for (let i = 0; i < count; i++) {
        const bit = document.createElement('i')
        bit.className = `rip-fx ${s.kind}`
        bit.style.setProperty('--x', `${s.x + (i - (count - 1) / 2) * 1.8}%`)
        bit.style.setProperty('--y', `${s.y + (i % 2) * 1.4}%`)
        bit.style.setProperty('--dx', `${s.dx * (1 + i * .12)}px`)
        bit.style.setProperty('--dy', `${s.dy * (1 + i * .10)}px`)
        bit.style.setProperty('--r', `${s.rot * (i % 2 ? -1 : 1)}deg`)
        bit.style.setProperty('--size', `${s.size * (1 + i * .10)}px`)
        bit.style.setProperty('--life', `${.82 + intensity * .72}s`)
        bit.style.setProperty('--c', s.color)
        fxLayer.appendChild(bit)
        window.setTimeout(() => bit.remove(), 2000)
      }
    }

    function addTear(index: number, p: number) {
      const h = hash(index * 2654435761 + cycle * 43)
      const anchors = [
        [31,48],[40,50],[50,52],[60,50],[69,48],
        [29,58],[39,60],[49,62],[59,61],[70,58],
        [34,69],[44,71],[55,71],[65,68],
      ]
      const [bx, by] = anchors[index % anchors.length]!
      const hole = document.createElement('i')
      hole.className = 'rip-hole'
      hole.style.setProperty('--x', `${bx + ((h >>> 7) % 7) - 3}%`)
      hole.style.setProperty('--y', `${by + ((h >>> 10) % 7) - 3}%`)
      hole.style.setProperty('--rot', `${-38 + (h % 76)}deg`)
      hole.style.setProperty('--w', `${17 + (h % 18) + p * 25}px`)
      hole.style.setProperty('--h', `${10 + ((h >>> 5) % 12) + p * 16}px`)
      tearField.appendChild(hole)
    }

    function setDamage(level: number) {
      for (let i = 1; i <= 20; i++) app.classList.toggle(`damage-${i}`, i <= level)
    }

    function majorBreak(index: number, p: number) {
      setDamage(index + 1)
      game.classList.remove('major-hit')
      void game.offsetWidth
      game.classList.add('major-hit')
      window.setTimeout(() => game.classList.remove('major-hit'), 620)
      const pieces = 8 + Math.floor(p * 11)
      for (let i = 0; i < pieces; i++) emitRupture(index * 31 + i, p, 1)
      addTear(index * 3 + 1, p)
      addTear(index * 3 + 2, p)
    }

    function reset() {
      tearField.replaceChildren()
      fxLayer.replaceChildren()
      fired.clear()
      setDamage(0)
      lastTx = 0
      nextRupture = ruptureStride
      nextTear = tearStride
      capyWrap.classList.remove('explode')
      game.classList.remove('booming')
      if (glasses) { glasses.style.opacity = '1'; glasses.style.transform = '' }
      if (chain) { chain.style.opacity = '1'; chain.style.transform = '' }
    }

    function explode() {
      setVisual(1)
      setDamage(20)
      capyWrap.classList.add('explode')
      game.classList.add('booming')
      app.dataset.simStage = '7'
      badge.textContent = `SIMULATION  ${total.toLocaleString()} / ${total.toLocaleString()} TX  ·  POP`
      for (let i = 0; i < 110; i++) emitRupture(500 + i, 1, 1)

      window.setTimeout(() => {
        if (winWallet) winWallet.textContent = 'THE LAST BUY POPPED THE CAPY'
        if (winCard) winCard.hidden = false
      }, 650)

      window.setTimeout(() => {
        if (winCard) winCard.hidden = true
        cycle += 1
        reset()
        setVisual(0)
        window.setTimeout(run, 1300)
      }, 4200)
    }

    function run() {
      const started = performance.now()
      const frame = (now: number) => {
        const p = Math.min(1, (now - started) / duration)
        const tx = Math.min(total, Math.floor(total * p))
        setVisual(p)
        badge.textContent = `SIMULATION  ${tx.toLocaleString()} / ${total.toLocaleString()} TX`

        while (lastTx < tx) {
          lastTx += 1
          if (lastTx >= nextRupture) {
            const idx = Math.min(499, Math.floor(lastTx / ruptureStride) - 1)
            emitRupture(idx, lastTx / total)
            nextRupture += ruptureStride
          }
          if (lastTx >= nextTear) {
            addTear(Math.floor(lastTx / tearStride), lastTx / total)
            nextTear += tearStride
          }
          if (lastTx % pumpStride === 0) pump()
        }

        milestones.forEach((mark, i) => {
          if (p >= mark && !fired.has(i)) {
            fired.add(i)
            majorBreak(i, p)
          }
        })

        if (p < 1) raf = requestAnimationFrame(frame)
        else explode()
      }
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(frame)
    }

    reset()
    setVisual(0)
    badge.textContent = `SIMULATION  0 / ${total.toLocaleString()} TX`
    window.setTimeout(run, 900)
  }
}
